import React from 'react';

import NoticeDot from '../../Feedback/NoticeDot';

import css from './style.module.scss';

interface Props {
  date: string | null;
  withNoticeDot: boolean;
  title: string;
  description: string;
  children?: React.ReactNode;
  onClick?: () => void;
}

const HistoryPanel = ({ date, withNoticeDot, title, description, children, onClick }: Props) => {
  return (
    <div className={css.historyPanel} onClick={onClick}>
      <div className={css.historyPanel__date}>
        {withNoticeDot ? <NoticeDot placement="left" /> : null}
        {date && <div>{date}</div>}
      </div>
      <div className={css.historyPanel__titleWithStatus}>
        <div className={css.historyPanel__title}>{title}</div>
        {children}
      </div>
      <div className={css.historyPanel__description}>{description}</div>
    </div>
  );
};

export default HistoryPanel;
